import type { ANCHOR_IDS } from '~/constants/anchors'

/**
 * Scrolls the given element into the center of the viewport.
 *
 * @param element The element to scroll into view.
 *
 * @example scrollElementIntoView(document.getElementById('element'))
 */
export function scrollElementIntoView(element?: Nullable<Element>) {
  element?.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
    inline: 'nearest',
  })
}

/**
 * Scrolls to the element with the given id.
 *
 * @param id The id of the element to scroll to.
 *
 * @example scrollToElement('conversation')
 */
export function scrollToElement(id: typeof ANCHOR_IDS[keyof typeof ANCHOR_IDS]) {
  const element = document.getElementById(id)

  scrollElementIntoView(element)
}

/**
 * Scrolls the first invalid field into the center of the viewport.
 *
 * @example scrollToInvalidFeedback()
 */
export function scrollToInvalidFeedback() {
  const invalidField = document.querySelector('[role="alert"]:not([aria-hidden="true"])')

  scrollElementIntoView(invalidField)
}

/**
 * Scrolls to the top of the page.
 *
 * @example scrollToTop()
 */
export function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}
